import { useEffect, useState } from "react";
import { CardArtPlaceholder } from "./CardArtPlaceholder";
import { CardSyntheticFace } from "./CardSyntheticFace";
import { classifyTwinImage } from "../utils/cardImage";

/** Grid preview: one face only when RingsDB uses a stacked / side-by-side twin PNG. */
export function CardFaceImage({ card, src, alt, loading, onError }) {
  const [twin, setTwin] = useState(null);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    setTwin(null);
    setLoadFailed(false);
  }, [src]);

  const onLoad = (e) => {
    const { naturalWidth: nw, naturalHeight: nh } = e.currentTarget;
    setTwin(classifyTwinImage(nw, nh));
  };

  const hover = "transition-transform group-hover:scale-[1.02]";

  if (loadFailed) {
    return (
      <div className="relative aspect-[5/7] w-full overflow-hidden bg-slate-950">
        {card ? (
          <CardSyntheticFace card={card} variant="tile" className="rounded-none border-slate-700/60" />
        ) : (
          <CardArtPlaceholder variant="tile" reason="broken" className="rounded-none border-slate-700/60" />
        )}
      </div>
    );
  }

  let imgClass;
  if (twin == null) {
    imgClass = `h-full w-full object-cover object-top ${hover}`;
  } else if (twin === "verticalTwin") {
    imgClass = `block h-auto w-full max-w-none ${hover}`;
  } else if (twin === "horizontalTwin") {
    imgClass = `block h-full w-auto max-w-none ${hover}`;
  } else {
    imgClass = `h-full w-full object-cover ${hover}`;
  }

  return (
    <div className="relative aspect-[5/7] w-full overflow-hidden bg-slate-950">
      <img
        src={src}
        alt={alt}
        referrerPolicy="no-referrer"
        loading={loading ?? "lazy"}
        decoding="async"
        className={imgClass}
        onLoad={onLoad}
        onError={(e) => {
          onError?.(e);
          setLoadFailed(true);
        }}
      />
    </div>
  );
}
